<div class="UserContactsGroup-header">
  <div class="UserContactsGroup-header-title">
    <div class="d-flex pt-2">
      <h4 class="title__page">Upload Contacts</h4>
      <app-info-tip-button [type]="'upload_contacts'"></app-info-tip-button>
    </div>
  </div>
</div>
<div class="d-flex justify-content-end pt-2">
  <app-button
    [text]="uploadButtonProperties.text"
    [color]="uploadButtonProperties.color"
    [size]="uploadButtonProperties.size"
    [Click]="uploadButtonProperties.onClick"></app-button>
</div>
<div class="d-flex pt-2 border-bottom">
  <h4>Previously Uploaded Files:</h4>
</div>
<div class="NoActionListing pt-3">
  <app-table
    [selectable]="false"
    [columns]="tableColumns"
    [dataSource]="dataSource"
    [dataSourceParams]="tableDataSourceParams"></app-table>
</div>
